import React, { useEffect, useState } from 'react';
import { IVenueDetailsProps } from './IVenueDetailsProps';
import './_venuedetails.css';
import { ApiHandler } from '../../services/apiHandler';
import ConfirmAlert from '../confirmAlert';
import ErrorAlert from '../ErrorAlert';
import SuccessAlert from '../SuccessAlert';
import WarningAlert from '../WarningAlert';
import Spinner from '../Spinner';
import { useNavigate } from 'react-router-dom';
import { getTechnology, getTechnologyDisplayValue } from '../../services/helper';
import { CloseOutlined, EnvironmentOutlined } from '@ant-design/icons';

export const VenueDetails: React.FC<IVenueDetailsProps> = (props) => {
  let navigate = useNavigate();
  const [venueDetails, setVenueDetails] = useState<any>();
  const [buildings, setBuildings] = useState<any[]>();
  const [loading, setLoading] = useState(false);
  const [assets, setAssets]: any = useState();
  const [totalAssets, setTotalAssets]: any = useState();
  const [outdoorAssets, setOutdoorAssets]: any = useState();
  const [totalAssetStatus, setTotalAssetStatus]: any = useState({ fieldTech: 0, cloud: 0, sas: 0, afc: 0 });
  const [outdoorAssetStatus, setOutdoorAssetStatus]: any = useState({ fieldTech: 0, cloud: 0, sas: 0, afc: 0 });
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState({ alert: false, message: '' });

  useEffect(() => {
    props.setBuildingId('');
  }, []);

  useEffect(() => {
    console.log('Venue ID in details:', props.venueId);
    if (props.venueId) {
      getVenueDetails();
      listBuildings();
    }
  }, [props.venueId]);

  const getVenueDetails = async () => {
    ApiHandler({ apiName: 'getVenue', body: {}, params: { venue_id: props.venueId } })
      .then((res) => {
        setVenueDetails(res.data);
        setAssets(res.data.asset);
        setTotalAssets(res.data.total_assets);
        setOutdoorAssets(res.data.outdoor_assets);
        setTotalAssetStatus({
          fieldTech: res.data.total_field_tech,
          cloud: res.data.total_cloud,
          sas: res.data.total_sas,
          afc: res?.data?.total_afc ?? 0,
        });
        setOutdoorAssetStatus({
          fieldTech: res.data.outdoor_field_tech,
          cloud: res.data.outdoor_cloud,
          sas: res.data.outdoor_sas,
          afc: res?.data?.outdoor_afc ?? 0,
        });
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error?.data?.message, alert: true });
        }
      });
  };

  const deleteVenue = async () => {
    setLoading(true);
    ApiHandler({ apiName: 'deleteVenue', body: {}, params: { venue_id: props.venueId } })
      .then((res) => {
        setLoading(false);
        setSuccess({ message: 'Venue Deleted Successfully', alert: true });
        setTimeout(() => {
          props.navigateTo('home');
        }, 1500);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const listBuildings = () => {
    setLoading(true);
    ApiHandler({ apiName: 'listBuildings', body: {}, params: { venue_id: props.venueId } })
      .then((res) => {
        setLoading(false);
        setBuildings(res.data);
        props.setBuildingsForVenue(res.data);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error?.data?.message, alert: true });
        }
      });
  };

  const goToBuilding = (building: any) => {
    props.setBuildingId(building.id);
    props.navigateTo('buildingDetails');
  };

  const checkAssetsInVenue = () => {
    if (buildings?.length !== 0) {
      setWarning({ message: 'Please delete buildings before deleting venue', alert: true });
    } else {
      let deleteMessage: string = '<span>Following assets are present.</span><br/><br/><ul>';
      assets?.forEach((asset: any) => {
        deleteMessage += '<li>' + asset.tracking_id + '</li>';
      });
      deleteMessage +=
        '</ul><i>On confirming the deletion, the assets will <b>automatically be dissociated from the Venue</b>. <br/><br/> Do you want to proceed?</i>';
      setDeleteConfirmationModal(
        assets?.length ? { alert: true, message: deleteMessage } : { alert: true, message: 'Are you sure you want to delete the Venue' }
      );
    }
  };

  const removeAssetsVenue = () => {
    setLoading(true);
    const requestBody: any = { asset_ids: [] };
    assets.forEach((asset: any) => {
      requestBody.asset_ids.push(asset.id);
    });
    ApiHandler({ apiName: 'removeAssetFromVenue', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        deleteVenue();
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  return (
    <div className="h-100 overflow-auto">
      <div className="app-card position-relative app-card-size right ">
        <div className="row-wise vertical-center">
          {/* <div className="row-wise vertical-center">
            <div
              className="icon-background-active"
              onClick={() => {
                props.navigateTo("home");
              }}
            >
              <span className="material-icons-round icon-active">arrow_back</span>
            </div>

            <label className="venue-name ms-3">{venueDetails?.name}</label>
          </div> */}

          <div className="row-wise space-between px-4 py-3 w-100 vertical-center">
            <span className="app-card-action-heading fw-bold"> {venueDetails?.name}</span>
            <div className="vertical-center">
              {/* Edit and delete options */}
              <div className="btn-group dropstart">
                <span
                  title="Options"
                  className="material-icons-round user-select-none cursor-pointer me-3"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  more_vert
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      type="button"
                      onClick={() => {
                        props.navigateTo('editVenue');
                      }}>
                      Edit
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item color-red"
                      type="button"
                      onClick={() => {
                        checkAssetsInVenue();
                      }}>
                      Delete
                    </button>
                  </li>
                </ul>
              </div>

              <CloseOutlined
                onClick={() => {
                  props.navigateTo('home');
                }}
                className="fs-6"
              />
              {/* <span className="material-icons-round icon-active">arrow_back</span> */}
            </div>
          </div>
        </div>
        <div className="border-bottom" />

        <div className="col-wise overflow-auto px-4 py-3">
          {/* <span className="text-color-secondary mb-2">Description</span> */}
          <span className="text-color-secondary mb-3 ps-1">{venueDetails?.description}</span>

          {/* <span className="text-color-secondary mb-2">Address</span> */}
          <div className="row-wise gap-8 align-items-center mb-4 ps-1">
            <EnvironmentOutlined className="info-icon-blue" />
            <span className="entity-label">{venueDetails?.address}</span>
          </div>
          <span className="text-color-secondary mb-3">{`${getTechnology() === 'wifi_6e' ? 'Wi-Fi' : '5G'} Devices`} </span>

          <div className="d-flex row-wise justify-content-between w-100">
            <div className="w-50">
              <span className="result-title text-center bold mb-2">Total in Venue</span>
              <div className=" me-1 result-box col-wise">
                <div className="d-flex align-items-center justify-content-between py-2">
                  <div className="d-flex col-wise">
                    <span className="result-label text-center">{totalAssets}</span>
                    <span className="result-title text-center bold">Total</span>
                  </div>
                  <div className="d-flex justify-content-start">
                    <div className="col-wise align-items-start">
                      <div className="d-flex row-wise align-items-center">
                        <label title="Field Tech" className="field-tech-circle me-1 "></label>
                        <span title="Field Tech" className="result-title">
                          {totalAssetStatus.fieldTech}
                        </span>
                        <span className="ms-1"> Field Tech</span>
                      </div>
                      <div className="d-flex row-wise align-items-center">
                        <label title="Cloud" className="cloud-circle me-1"></label>
                        <span title="Cloud" className="result-title">
                          {totalAssetStatus.cloud}
                        </span>
                        <span className="ms-1"> Cloud</span>
                      </div>
                      {getTechnology() !== 'wifi_6e' && (
                        <div className="d-flex row-wise align-items-center">
                          <label title="SAS" className="sas-circle me-1"></label>
                          <span title="SAS" className="result-title">
                            {totalAssetStatus.sas}
                          </span>
                          <span className="ms-1"> SAS</span>
                        </div>
                      )}

                      {getTechnology() !== 'cbrs_5g' && (
                        <div className="d-flex row-wise align-items-center">
                          <label title="AFC" className="sas-circle me-1"></label>
                          <span title="AFC" className="result-title">
                            {totalAssetStatus.afc}
                          </span>
                          <span className="ms-1"> AFC</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-50">
              <span className="result-title text-center bold mb-2">Outdoor Only</span>
              <div className=" me-1 result-box col-wise">
                <div className="d-flex align-items-center justify-content-between py-2">
                  <div className="d-flex col-wise">
                    <span className="result-label text-center">{outdoorAssets}</span>
                    <span className="result-title text-center bold">Total</span>
                  </div>
                  <div className="d-flex justify-content-start">
                    <div className="col-wise align-items-start">
                      <div className="d-flex row-wise align-items-center">
                        <label title="Field Tech" className="field-tech-circle me-1 "></label>
                        <span title="Field Tech" className="result-title">
                          {outdoorAssetStatus.fieldTech}
                        </span>
                        <span className="ms-1"> Field Tech</span>
                      </div>
                      <div className="d-flex row-wise align-items-center">
                        <label title="Cloud" className="cloud-circle me-1"></label>
                        <span title="Cloud" className="result-title">
                          {outdoorAssetStatus.cloud}
                        </span>
                        <span className="ms-1"> Cloud</span>
                      </div>
                      {getTechnology() !== 'wifi_6e' && (
                        <div className="d-flex row-wise align-items-center">
                          <label title="SAS" className="sas-circle me-1"></label>
                          <span title="SAS" className="result-title">
                            {outdoorAssetStatus.sas}
                          </span>
                          <span className="ms-1"> SAS</span>
                        </div>
                      )}

                      {getTechnology() !== 'cbrs_5g' && (
                        <div className="d-flex row-wise align-items-center">
                          <label title="AFC" className="sas-circle me-1"></label>
                          <span title="AFC" className="result-title">
                            {outdoorAssetStatus.afc}
                          </span>
                          <span className="ms-1"> AFC</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row-wise justify-content-between mt-4 mb-3" style={{ alignItems: 'center' }}>
            <label className="text-color">BUILDINGS</label>

            <span
              title="Add New Building"
              className="material-icons-round add-icon"
              onClick={() => {
                props.navigateTo('addBuilding');
                props.setBuildingNavigation('venueDetails');
              }}>
              add_circle_outline
            </span>
          </div>

          <div className="overflow-auto">
            {buildings?.map((building: any) => {
              return (
                <div
                  className="building-card"
                  onClick={() => {
                    goToBuilding(building);
                  }}
                  key={building.id}>
                  {/* Image */}
                  {building.image && building.image !== '' ? (
                    <img src={building.image} className=" building-image-box image" />
                  ) : (
                    <div className="building-image-box">
                      <span className="material-icons-outlined icon">apartment</span>
                    </div>
                  )}
                  {/* Details */}
                  <div className="row-wise vertical-center">
                    <div className="building-details ms-3 w-100">
                      <div className="row-wise vertical-center justify-content-between w-100 mb-2">
                        <label className="name">{building.name}</label>
                      </div>
                      {building.address && (
                        <div className="row-wise align-items-start gap-8">
                          <EnvironmentOutlined className="info-icon-blue pt-1" />
                          <label className="description mb-2 h-100">{building.address}</label>
                        </div>
                      )}
                      <div className="row-wise vertical-center ">
                        <div title="Field Tech" className="field-tech-circle me-1 "></div>
                        <span className="total-floors">{`${building.total_assets} ${getTechnologyDisplayValue[getTechnology()]} devices`}</span>
                        <div title="Cloud" className="cloud-circle ms-2 me-1"></div>
                        <span className="total-floors">{building.total_floors} Floors</span>
                      </div>
                    </div>
                    <span className="material-icons-outlined icon ms-2">navigate_next</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <Spinner show={loading} />

      {/* Delete confirmation modal */}
      <ConfirmAlert
        message={deleteConfirmationModal.message}
        primaryText={'Yes'}
        secondaryText={'No'}
        secondaryAction={() => {
          setDeleteConfirmationModal({ alert: false, message: '' });
        }}
        visible={deleteConfirmationModal.alert}
        title={`Delete Venue`}
        primaryAction={() => {
          setDeleteConfirmationModal({ alert: false, message: '' });
          assets?.length !== 0 ? removeAssetsVenue() : deleteVenue();
        }}
        onClose={() => {
          setDeleteConfirmationModal({ alert: false, message: '' });
        }}
      />

      <ErrorAlert
        show={error.alert}
        onDismiss={() => {
          setError({ message: '', alert: false });
        }}
        message={error.message}
      />
      <SuccessAlert
        show={success.alert}
        onDismiss={() => {
          setSuccess({ message: '', alert: false });
        }}
        message={success.message}
      />
      <WarningAlert
        show={warning.alert}
        onDismiss={() => {
          setWarning({ message: '', alert: false });
        }}
        message={warning.message}
      />
    </div>
  );
};
